import { useTenantMemberships } from "./useTenantContext";
import { getActiveTenantId } from "../services/workspace/activeWorkspace";

/** True when the signed-in user's membership in the active organization holds `permission` (the backend still enforces it). */
export const useTenantPermission = (permission: string): { allowed: boolean; loading: boolean } => {
  const { data: memberships, isLoading } = useTenantMemberships();
  const tenantId = getActiveTenantId();
  const allowed = Boolean(
    memberships?.some((membership) => membership.tenant_id === tenantId && membership.permissions.includes(permission)),
  );
  return { allowed, loading: isLoading };
};
